import React, { useEffect } from "react";
import svg7 from "../../../../../../assets/svg/svg7.svg";
import svg33 from "../../../../../../assets/svg/svg33.svg";
import { Descriptions, Divider, Progress } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ProjectCard from "./ProjectCard";
import ProjectTeamTable from "./project-member/ProjectTeamTable";
import { cashConverter } from "../../../../../../utils";
import { fetchData } from "../../../../../../features/fetch/fetchSlice";
import moment from "moment";

function ProjectList() {
  const urlSingle = "api/v2/main_projects/get";
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.fetch);
  const { loading, activeObjOngoingProject, dataProjSingle } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      activeObjOngoingProject: state.obj.activeObj["ongoingProject"],
      dataProjSingle: state.fetch.data[urlSingle] || [],
    })
  );
  const { refetchKey } = useSelector((state) => state.global);

  const navigate = useNavigate();

  // Calculate time elapsed from start date to today in months and days
  const startDate = dataProjSingle?.[0]?.projectStartDate;
  const endDate = dataProjSingle?.[0]?.projectEndDate;

  let elapsedText = "--";
  let elapsedPercent = 0;

  if (startDate) {
    const start = moment(startDate);
    const end = endDate ? moment(endDate) : null;
    const isCompleted = dataProjSingle?.[0]?.projectStatus?.toUpperCase() === "COMPLETED";
    const reference = isCompleted && end ? end : moment();

    const months = reference.diff(start, "months");
    const days = reference.diff(start.clone().add(months, "months"), "days");
    elapsedText = `${months} month${months !== 1 ? "s" : ""} ${days} day${days !== 1 ? "s" : ""}`;

    if (end) {
      const totalDuration = end.diff(start, "days");
      const elapsedDuration = reference.diff(start, "days");
      elapsedPercent = totalDuration > 0 ? Math.round((elapsedDuration / totalDuration) * 100) : 0;
    }
  }

  const items1 = [
    {
      key: "1",
      label: "Individual in Charge",
      children: activeObjOngoingProject?.projectEngineerName ?? "N/A",
    },
    {
      key: "5",
      label: "Consultant",
      children: activeObjOngoingProject?.projectContractor ?? "N/A",
    },
    {
      key: "2",
      label: "Contract Amount",
      children: (
        <div>{cashConverter(activeObjOngoingProject?.projectCost)}</div>
      ),
    },
    {
      key: "4",
      label: "Start Date",
      children: (
        <div>
          {dataProjSingle?.[0]?.projectStartDate
            ? moment(dataProjSingle?.[0]?.projectStartDate)?.format(
                "DD-MM-YYYY"
              )
            : "--"}
        </div>
      ),
    },
    {
      key: "5",
      label: "End Date",
      children: (
        <div>
          {dataProjSingle?.[0]?.projectEndDate
            ? moment(dataProjSingle?.[0]?.projectEndDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "3",
      label: "Time Elapsed",
      children: (
        <div className="flex items-center gap-x-2">
          <span>{elapsedText}</span>
          {endDate && (
            <span
              className="font-[500] text-[.75rem]"
              style={{ color: elapsedPercent > 100 ? "#B81B0E" : "#4FAD5B" }}
            >
              ({elapsedPercent}%)
            </span>
          )}
        </div>
      ),
    },
  ];

  async function fetchSingleProjData() {
    await dispatch(
      fetchData({
        url: urlSingle,
        projectId: activeObjOngoingProject?.projectId,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    if (refetchKey == 1) {
      fetchSingleProjData();
    }
  }, [refetchKey]);

  useEffect(() => {
    fetchSingleProjData();
  }, []);

  return (
    <div>
      <div className="text-[#0092CC] font-interSans font-[500] text-[.75rem]">
        {dataProjSingle?.[0]?.projectNumber}
      </div>
      <div className="form-add-h !text-[#050505] mt-[.63rem]">
        {dataProjSingle?.[0]?.projectName}
      </div>
      <div className="proj_desc mt-[.62rem]">
        {dataProjSingle?.[0]?.projectRemarks}
      </div>
      <div className="mt-[1.25rem] flex lg:flex-row flex-col gap-y-2 lg:items-center gap-x-[.62rem] w-full">
        <div className="flex items-center gap-x-1">
          <img src={svg7} alt="svg7" />
          <span className="forgot-text">
            {" "}
            {dataProjSingle?.[0]?.projectCountyName}
          </span>
        </div>

        <div className="flex items-center gap-x-1 ">
          <img src={svg33} alt="svg33" />
          <span className="forgot-text">
            {dataProjSingle?.[0]?.projectAgencyName}
          </span>
        </div>

        <div className="flex  items-center flex-1 gap-x-[.62rem]">
          <span className="forgot-text lg:flex hidden">| Progress</span>
          <Progress
            strokeColor={
              dataProjSingle?.[0]?.projectDisbursementPercentage >
              dataProjSingle?.[0]?.projectCompletionRate
                ? "#B81B0E"
                : "#4FAD5B"
            }
            className="lg:w-[30%] w-full"
            percent={dataProjSingle?.[0]?.projectCompletionRate}
            format={() => (
              <span
                style={{
                  color:
                    dataProjSingle?.[0]?.projectDisbursementPercentage >
                    dataProjSingle?.[0]?.projectCompletionRate
                      ? "#B81B0E"
                      : "#4FAD5B",
                }}
              >
                {dataProjSingle?.[0]?.projectCompletionRate}%
              </span>
            )}
          />
        </div>
      </div>

      <div className="flex items-center lg:flex-row flex-col mt-[2.5rem] w-full">
        <div className="w-full">
          <Descriptions
            labelStyle={{ width: 150 }}
            column={1}
            colon={true}
            items={items1}
          />
        </div>

        <div className="w-full">
          <ProjectCard />
        </div>
      </div>

      <div className="mt-[2.44rem]">
        <Divider />
      </div>
      <ProjectTeamTable />
    </div>
  );
}

export default ProjectList;
